import React, {Component} from 'react';
import PropTypes from "prop-types";
import StaticFunctions from "../../utils/StaticFunctions";
import Api from "../../utils/Api";
import Select from "react-select";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import InputField from "../../utils/InputField";
import Timeformat from "../../utils/Timeformat";
import TextAreaField from "../../utils/TextAreaField";
import TableContainer from "../../utils/TableContainer";

class DataCollectorEditContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        datacollector: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            machines: [],
            companies: [],
            locations: [],
            currentCompanyId: null,
            currentLocationId: null,
            inputParams: {}
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestCompaniesForUser = this.requestCompaniesForUser.bind(this);
        this.requestMachinesForDataCollector = this.requestMachinesForDataCollector.bind(this);
        this.getInput = this.getInput.bind(this);
        this.selectCompany = this.selectCompany.bind(this);
        this.selectLocation = this.selectLocation.bind(this);
        this.editSelect = this.editSelect.bind(this);

    }

    componentWillMount() {

        this.requestCompaniesForUser();
        this.requestMachinesForDataCollector();

        if (this.props.datacollector) {
            this.setState({
                currentCompanyId: this.props.datacollector.id_company,
                currentLocationId: this.props.datacollector.id_location,
                inputParams: this.props.datacollector
            });
        }

    }

    requestCompaniesForUser() {

        if (this.props.baseData.checkUserRole('superadmin') || this.props.baseData.checkUserRole('zskadmin')) {
            const opts = StaticFunctions.getSelectOptionsFromArray(this.props.baseData.companies.companies, 'id', 'label');
            const locations = StaticFunctions.getSelectOptionsFromArray(this.getLocationsByCompanyId(this.props.datacollector.id_company));

            this.setState({
                locations: locations,
                companies: opts
            });
        } else {
            const locations = StaticFunctions.getSelectOptionsFromArray(this.getLocationsByCompanyId(this.props.datacollector.id_company));
            const params = {
                action: 'getCompaniesForUser',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                companyId: this.props.datacollector.id_company,
                userId: this.props.baseData.userData.id
            };

            const callback = function (res) {
                if (res) {
                    this.setState({
                        locations: locations,
                        companies: res
                    });
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        }

    }

    requestMachinesForDataCollector() {

        if (this.props.datacollector) {
            const params = {
                action: 'getDataCollectorMachines',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                dataCollectorId: this.props.datacollector.id,
                companyId: this.props.datacollector.id_company
            };

            const callback = function (res) {
                if (res) {
                    this.setState({
                        machines: res
                    });
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        }

    }

    enterSaveEditDataCollector(event) {

        if (event.keyCode === 13) {
            this.saveEditDataCollector();
        } else if (event.keyCode === 27) {
            this.props.changeView();
        }

    }

    saveEditDataCollector() {

        const currentCompanyId = this.state.currentCompanyId;
        const currentLocationId = this.state.currentLocationId;
        const inputParams = this.state.inputParams;

        if (inputParams) {
            const params = {
                action: 'editDataCollector',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                id: inputParams.id,
                companyId: currentCompanyId,
                locationId: currentLocationId
            };

            const callback = function (res) {
                if (res) {
                    alert(this.translate(res.msgKey));

                    if (res.success) this.props.changeView();
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback, null);
        }

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = (isValid) ? value : '';

        this.setState({inputParams});

    }

    editSelect(event, key) {

        const newInput = {...this.state.inputParams};

        newInput[key] = event.value;

        this.setState({
            inputParams: newInput
        });

    }

    selectCompany(event) {

        const currentCompanyId = (event && event.value) ? event.value : null;
        const locations = StaticFunctions.getSelectOptionsFromArray(this.getLocationsByCompanyId(currentCompanyId));

        this.setState({
            locations: locations,
            currentCompanyId: currentCompanyId,
            currentLocationId: null
        });

    }

    selectLocation(event) {

        const currentLocationId = ((event && event.value)) ? event.value : null;

        this.setState({
            currentLocationId
        });

    }

    getCompanyNameById(id) {

        const companies = this.props.baseData.companies.companies;

        if (companies) {
            for (let ix in companies) {
                let c = companies[ix];

                if (String(c.id) === String(id)) return c.name;
            }
        }

        return id;

    }

    getLocationNameById(id) {

        const locations = this.props.baseData.locations;

        if (locations) {
            for (let ix in locations) {
                let c = locations[ix];

                if (String(c.id) === String(id)) return c.name;
            }
        }

        return id;

    }

    getLocationsByCompanyId(id) {

        if (!id) return [];

        const locations = this.props.baseData.locations;

        return locations.filter((location) => String(location.id_company) === String(id));

    }

    getTableColumns() {

        return [
            {
                key: 'machineId',
                nameKey: 'machineId',
                sortType: 'string',
            },
            {
                key: 'machineName',
                nameKey: 'machineName',
                sortType: 'string',
            },
            {
                key: 'location',
                nameKey: 'location',
                sortType: 'string',
            },
            {
                key: 'heads',
                nameKey: 'heads',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'needles',
                nameKey: 'needles',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'lastSeen',
                nameKey: 'lastSeen',
                sortType: 'date',
            },
            {
                key: 'lastTransmission',
                nameKey: 'lastTransmission',
                sortType: 'date',
            }
        ];

    }

    getTableRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const data = (this.state.machines) ? this.state.machines : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let lastSeen = (rowTemp.last_seen) ? Timeformat.fromUnix(rowTemp.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
            let lastOperation = (rowTemp.last_seen) ? Timeformat.fromUnix(rowTemp.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

            rows.push({
                machineId: rowTemp.machine_id,
                machineName: rowTemp.machine_name,
                location: rowTemp.location_name,
                heads: rowTemp.heads,
                needles: rowTemp.needles,
                lastSeen: lastSeen,
                lastOperation: lastOperation
            });
        }

        return rows;

    }

    renderCompanyFormField() {

        if (this.props.baseData.checkUserRole('superadmin') || this.props.baseData.checkUserRole('zskadmin')) {
            const currentCompanyId = (this.state.currentCompanyId) ? this.state.currentCompanyId : null;
            const options = StaticFunctions.getSortedData(this.state.companies, 'label', 'string');

            return (
                <td className="text-left">
                    <Select
                        name="company"
                        className="chosen-container chosen-container-single"
                        style={{width: '260px'}}
                        options={options}
                        onChange={this.selectCompany}
                        value={options.find(o => String(o.value) === String(currentCompanyId)) || null}
                        placeholder={this.translate('select') + '...'}
                        clearable={true}
                        noResultsText={this.translate('noResultsFound')}
                    />
                </td>
            );
        } else {
            const inputParams = this.state.inputParams;

            return (
                <td className="text-left">
                    <InputField
                        name="company"
                        value={this.getCompanyNameById(inputParams.id_company)}
                        disabled={true}
                    />
                </td>
            );
        }

    }

    renderLocationFormField() {

        if (this.props.baseData.checkUserRole('superadmin') || this.props.baseData.checkUserRole('zskadmin')) {
            const currentLocationId = (this.state.currentLocationId) ? this.state.currentLocationId : null;
            const locations = StaticFunctions.getSortedData(this.state.locations, 'label', 'string');

            return (
                <td className="text-left">
                    <Select
                        name="location"
                        className="chosen-container chosen-container-single"
                        style={{width: '260px'}}
                        options={locations}
                        onChange={this.selectLocation}
                        value={locations.find(o => String(o.value) === String(currentLocationId)) || null}
                        placeholder={this.translate('select') + '...'}
                        clearable={true}
                        noResultsText={this.translate('noResultsFound')}
                    />
                </td>
            );
        } else {
            const inputParams = this.state.inputParams;

            return (
                <td className="text-left">
                    <InputField
                        name="location"
                        value={this.getLocationNameById(inputParams.id_location)}
                        disabled={true}
                    />
                </td>
            );
        }

    }

    renderFormButtons() {

        if (this.props.baseData.checkUserRole('superadmin') || this.props.baseData.checkUserRole('zskadmin')) {
            return (
                <tr>
                    <td className="text-left labelSpan webElement">&nbsp;</td>

                    <td className="text-left">
                        <a className="formButton" onClick={() => this.props.changeView()}>
                            {this.translate('cancel')}
                        </a>

                        <a className="formButton" onClick={() => this.saveEditDataCollector()}
                           onKeyDown={(event) => this.enterSaveEditDataCollector(event)}>
                            {this.translate('save')}
                        </a>
                    </td>
                </tr>
            );
        } else {
            return (
                <tr>
                    <td className="text-left labelSpan webElement">&nbsp;</td>

                    <td className="text-left">
                        <a className="formButton" onClick={() => this.props.changeView()}>
                            {this.translate('backToOverview')}
                        </a>
                    </td>
                </tr>
            );
        }

    }

    render() {

        if (!this.props.datacollector && !this.state.inputParams) return <LoadingSplash color={'dark'} />;

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const inputParams = this.state.inputParams;
        const dateCreated = (inputParams.date_created) ? Timeformat.fromUnix(inputParams.date_created).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
        const lastSeen = (inputParams.last_seen) ? Timeformat.fromUnix(inputParams.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

        const localIpPort1 = ((inputParams.local_ip1) ? inputParams.local_ip1 : '') + ':' + ((inputParams.local_tcp_port) ? inputParams.local_tcp_port : '');
        const localIpPort2 = ((inputParams.local_ip2) ? inputParams.local_ip2 : '') + ':' + ((inputParams.local_udp_port) ? inputParams.local_udp_port : '');

        const companyFormField = this.renderCompanyFormField();
        const locationFormField = this.renderLocationFormField();
        const formButtons = this.renderFormButtons();

        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('detailsDataCollector')}</h1>
                </nav>

                <div className="clearfix">
                    <div className="col-lg-4">
                        <div className="formRow">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('id')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="id"
                                                value={inputParams.id}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('company')}</td>

                                        {companyFormField}
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('location')}</td>

                                        {locationFormField}
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('machinesDataCollector')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="machinesDataCollector"
                                                value={inputParams.machine_count}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('localIpPort') + ' (' + this.translate('lan') + ')'}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="localIpPort1"
                                                value={(localIpPort1 !== ':') ? localIpPort1 : '-'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('localIpPort') + ' (' + this.translate('wan') + ')'}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="localIpPort2"
                                                value={(localIpPort2 !== ':') ? localIpPort2 : '-'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('globalIp')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="globalIp"
                                                value={inputParams.last_remote_addr}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('clientVersion')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="clientVersion"
                                                value={inputParams.client_version}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('freeMemory') + ' (' + this.translate('log') + ')'}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="spaceFree1"
                                                value={StaticFunctions.addThousandsSeparator(inputParams.log_space_free) + ' mb'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('freeMemory') + ' (' + this.translate('program') + ')'}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="spaceFree2"
                                                value={StaticFunctions.addThousandsSeparator(inputParams.program_space_free) + ' mb'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('freeMemory') + ' (' + this.translate('buffer') + ')'}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="spaceFree3"
                                                value={StaticFunctions.addThousandsSeparator(inputParams.buffer_space_free) + ' mb'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('cpuUsage')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="cpuUsage1"
                                                value={StaticFunctions.addThousandsSeparator(inputParams.cpu_load) + ' / ' + StaticFunctions.addThousandsSeparator(inputParams.cpu_processload)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('ramUsage') + ' (' + this.translate('usage') + ')'}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="ramUsage2"
                                                value={StaticFunctions.addThousandsSeparator(inputParams.ram_process) + ' kb'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('ramUsage') + ' (' + this.translate('total') + ')'}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="ramUsage3"
                                                value={StaticFunctions.addThousandsSeparator(inputParams.ram_total) + ' kb'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('ramUsage') + ' (' + this.translate('free') + ')'}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="ramUsage"
                                                value={StaticFunctions.addThousandsSeparator(inputParams.ram_free) + ' kb'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('dateCreated')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="dateCreated"
                                                value={dateCreated}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('lastSeen')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="lastSeen"
                                                value={lastSeen}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('hardware')}</td>

                                        <td className="text-left">
                                            <TextAreaField
                                                name="hardware"
                                                value={inputParams.hardware_type}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    {formButtons}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-lg-8">
                        <TableContainer
                            baseData={this.props.baseData}
                            columns={tableColumns}
                            rows={tableRows}
                            fillGaps="-"
                        />
                    </div>
                </div>
            </div>
        );

    }

}

export default DataCollectorEditContainer;
